import { createAction } from 'redux-actions';

export const clearInventoryPackages = createAction('CLEAR_INVENTORY_PACKAGES');

export const clearInventoryPackagesAvailability = createAction(
  'CLEAR_INVENTORY_PACKAGES_AVAILABILITY'
);

export const inventoryPackagesOnChangePage = createAction(
  'INVENTORY_PACKAGES_ON_CHANGE_PAGE'
);

export const inventoryPackagesOnChangeOrder = createAction(
  'INVENTORY_PACKAGES_ON_CHANGE_ORDER'
);

export const inventoryPackagesAvailabilityOnChangePage = createAction(
  'INVENTORY_PACKAGES_AVAILABILITY_ON_CHANGE_PAGE'
);

export const inventoryPackagesAvailabilityOnChangeOrder = createAction(
  'INVENTORY_PACKAGES_AVAILABILITY_ON_CHANGE_ORDER'
);

export const resetInventoryPackageDeleted = createAction(
  'RESET_INVENTORY_PACKAGE_DELETED'
);
